import { useState } from "react";
import { motion } from "framer-motion";
import { MapPin, CheckCircle, XCircle } from "lucide-react";

const DAKAR_COMMUNES = [
  "Dakar Plateau",
  "Médina",
  "Fann / Point E / Amitié",
  "Grand Dakar",
  "Hann Bel-Air",
  "Parcelles Assainies",
  "Grand Yoff",
  "Ouakam / Ngor / Yoff",
  "Pikine",
  "Guédiawaye",
  "Keur Massar",
  "Rufisque",
  "Diamniadio",
];

const ServiceStrip = () => {
  const [selected, setSelected] = useState("");
  const [checked, setChecked] = useState(false);

  const handleCheck = () => {
    if (selected) setChecked(true);
  };

  // All Dakar communes are serviceable at launch
  const isServiceable = checked && selected !== "";

  return (
    <section className="section-padding bg-background">
      <div className="container-max px-5 sm:px-8 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="max-w-lg mx-auto"
        >
          <div className="bg-card rounded-xl shadow-sm border border-border p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-xl bg-secondary/10 flex items-center justify-center">
                <MapPin size={20} className="text-secondary" />
              </div>
              <h3 className="font-display text-lg font-bold text-foreground">
                Vérifier ma zone de livraison
              </h3>
            </div>
            <p className="text-sm text-muted-foreground mb-4">
              Vérifiez si votre zone est couverte par notre service de livraison.
            </p>

            <div className="flex flex-col sm:flex-row gap-2">
              <select
                value={selected}
                onChange={(e) => {
                  setSelected(e.target.value);
                  setChecked(false);
                }}
                className="flex-1 px-4 py-3 rounded-xl border border-border bg-background text-foreground text-sm focus:outline-none focus:ring-2 focus:ring-secondary/40 appearance-none"
              >
                <option value="">Sélectionnez votre commune</option>
                {DAKAR_COMMUNES.map((c) => (
                  <option key={c} value={c}>{c}</option>
                ))}
              </select>
              <button
                onClick={handleCheck}
                disabled={!selected}
                className="px-5 py-3 rounded-xl bg-secondary text-secondary-foreground font-semibold text-sm hover:bg-gold-light transition-colors disabled:opacity-40"
              >
                Vérifier
              </button>
            </div>

            {checked && (
              <motion.div
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                className="mt-4 flex items-center gap-2"
              >
                {isServiceable ? (
                  <>
                    <CheckCircle size={18} className="text-green-600" />
                    <span className="text-sm font-medium text-green-700">
                      Oui, nous livrons à {selected} !
                    </span>
                  </>
                ) : (
                  <>
                    <XCircle size={18} className="text-amber-600" />
                    <span className="text-sm font-medium text-amber-700">
                      Cette zone sera bientôt disponible.
                    </span>
                  </>
                )}
              </motion.div>
            )}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ServiceStrip;
